import * as React from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import SquareIcon from "@mui/icons-material/SquareRounded";
import { NodeModel, useDragOver } from "@minoru/react-dnd-treeview";
// Components
import Add from "@mui/icons-material/Add";
import Checkbox from "@mui/material/Checkbox";
import Remove from "@mui/icons-material/Remove";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
// Types
import { StyledTreeItemProps } from "src/@types/Category";
// Constants
import { ALLOW_SELECTION_FROM_AND_ONWARDS } from "src/constants/TreeData";

/* eslint-disable  @typescript-eslint/no-explicit-any */
type Generic = any;

type Props = {
  depth: number;
  isOpen: boolean;
  node: NodeModel;
  setQuestionTags?: Generic;
  selectedTags: Array<string>;
  onToggle: (id: NodeModel["id"]) => void;
};

type QuestionTagProps = StyledTreeItemProps & Props;

const QuestionTagTreeItem: React.FC<QuestionTagProps> = ({
  node,
  color,
  depth,
  isOpen,
  bgColor,
  onToggle,
  childs,
  selectedTags,
  setQuestionTags,
  showActions = true,
  handleAddCategoriesSheet,
  ...other
}) => {
  const { id, text } = node;

  const dragOverProps = useDragOver(id, isOpen, onToggle);

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    onToggle(id);

    const currentTarget = e.currentTarget;
    const ele: Generic = e.currentTarget.parentNode;
    const line: Generic =
      e.currentTarget.parentNode.parentNode.parentNode.childNodes[0]
        .childNodes[0];
    const grandParent: Generic =
      e.currentTarget.parentNode.parentNode.parentNode;
    setTimeout(() => {
      if (currentTarget.nextElementSibling == null) {
        currentTarget.classList.remove("active-blk");
      } else {
        currentTarget.classList.add("active-blk");
      }
      if (line.classList.contains("shape")) {
        const list = ele.parentNode;
        for (let i = 0; i < list.childNodes.length; i++) {
          if (
            ele === list.childNodes[list.childNodes.length - 1] &&
            ele.classList.contains("child")
          ) {
            line.style.height =
              grandParent.offsetHeight - ele.offsetHeight - 4 + "px";
          }
        }
      }

      const list: Generic = document.getElementsByTagName("li");
      for (let i = 0; i < list.length; i++) {
        if (list[i].childNodes[0].classList.contains("hasChilds")) {
          list[i].classList.add("child");
        }
      }
    }, 50);
  };

  const getParentEle = (ele) => {
    const grandParent: Generic = ele.parentNode.parentNode.parentNode;
    if (grandParent.tagName === "LI") {
      grandParent.childNodes[0].classList.add("hover-active");
      if (grandParent.childNodes[0].parentNode) {
        getParentEle(grandParent.childNodes[0]);
      }
    }
  };

  const handleHover = (e: React.MouseEvent) => {
    const ele: Generic = e.currentTarget;
    getParentEle(ele);
    const list: Generic = document.getElementsByClassName("tree-item-content");
    for (let i = 0; i < list.length; i++) {
      list[i].classList.add("disable-sqaures");
    }
  };

  const handleHoverOut = () => {
    const list: Generic = document.getElementsByClassName("tree-item-content");
    for (let i = 0; i < list.length; i++) {
      if (list[i].classList.contains("disable-sqaures")) {
        list[i].classList.remove("disable-sqaures");
      }
      if (list[i].classList.contains("hover-active")) {
        list[i].classList.remove("hover-active");
      }
    }
  };

  return (
    <Box
      onClick={handleToggle}
      onMouseEnter={handleHover}
      onMouseLeave={handleHoverOut}
      className={
        "align-center-corner tree-item-content" +
        `${childs !== "0" ? " hasChilds" : ""}`
      }
      {...dragOverProps}
    >
      <Box className="shape" />
      <Box className="icon-square-wrap">
        <SquareIcon className="icon-square" sx={{ color: "#0A75F5" }} />
      </Box>

      <Typography variant="body2" sx={{ fontWeight: "inherit", flexGrow: 1 }}>
        {text}
      </Typography>

      {showActions ? (
        <Box className="right-blk custom-input-wrap">
          {depth >= ALLOW_SELECTION_FROM_AND_ONWARDS ? (
            <FormControlLabel
              label=""
              control={
                <Checkbox
                  checkedIcon={<CheckCircleIcon />}
                  icon={<RadioButtonUncheckedIcon />}
                  onClick={() => setQuestionTags(id)}
                  checked={selectedTags?.includes(id as string)}
                />
              }
            />
          ) : null}

          {isOpen && parseInt(childs) > 0 ? (
            <Box
              className="icon-rmv"
              component={Remove}
              // onClick={parseInt(childs) > 0 ? handleToggle : null} // Making AI Tag expansion/plus and Contraction/minus signs Disfunction
            />
          ) : null}

          {!isOpen && parseInt(childs) > 0 ? (
            <Box
              className="icon-rmv"
              component={Add}
              // onClick={handleToggle} // Making AI Tag expansion/plus and Contraction/minus signs Disfunction
            />
          ) : null}
        </Box>
      ) : null}
    </Box>
  );
};

export default QuestionTagTreeItem;
